<template>
  <div class="switch-container" @click="onChangeSwitchValue">
    <!-- <div class="switch-group" :class="{ on: switchValue, dark: !switchValue }"> -->
    <div class="switch-group">
      <div class="round"></div>
    </div>
  </div>
</template>

<script>
export default {
  // props: ["switchValue"],
  methods: {
    onChangeSwitchValue: function() {
      this.$emit("switchValueChanged");
    }
  }
};
</script>

<style lang="scss">
.switch-container {
  display: flex;
  padding-top: 5px;
  margin-right: 22px;
  .switch-group {
    display: flex;
    width: 68px;
    height: 22px;
    font-size: 11px;
    line-height: 22px;
    cursor: pointer;
    border-radius: 3px;

    .round {
      display: flex;
      align-items: center;

      &:before,
      &:after {
        padding: 4px;
        text-align: center;
        text-align: center;
        font-size: 11px;
        line-height: 14px;
        transition: all 0.5s;
      }
      &:before {
        content: "Bright";
      }
      &:after {
        content: "Dark";
      }
    }
  }
  .round {
    height: 100%;
    border-radius: 3px;
  }
}
.light {
  .round {
    justify-content: flex-start;
    &:before {
      color: var(--text-lightest);
      background-color: #393939;
      border-radius: 3px;
    }
    &:after {
      color: var(--text-5);
      background-color: transparent;
    }
  }
}
.dark {
  .round {
    justify-content: flex-end;
    &:before {
      color: var(--text-5);
      background-color: transparent;
    }
    &:after {
      color: var(--text-lightest);
      background-color: #393939;
      border-radius: 3px;
    }
  }
}
</style>
